import React from 'react';

import { IVariation } from '../../../types/contentful';

import { usePageDataContext } from '../../context/PageData';

import { VariationContainer } from '../VariationContainer';
import { WebBanner } from '../WebBanner/index';
import { useRouter } from 'next/router';
import { getLearningCenterBanner } from '../../utils/getCategorySpecificBanner';

interface BannerProps {
  toggleBanner: Function;
  roundedCornersVariation?: boolean;
  pageWebBanner?: any;
}

export function Banners({
  toggleBanner,
  roundedCornersVariation,
  pageWebBanner
}: BannerProps) {
  const router = useRouter();

  const {
    config: { webBanner: globalWebBanner } = {},
    articleConfig
  } = usePageDataContext();

  // Extract category slug from learning center URLs
  const getCategorySlugFromPath = (path: string): string | undefined => {
    if (!path.includes('learning-center')) return undefined;
    
    const pathParts = path.split('/');
    const learningCenterIndex = pathParts.indexOf('learning-center');
    
    if (learningCenterIndex !== -1 && pathParts[learningCenterIndex + 1]) {
      return pathParts[learningCenterIndex + 1];
    }
    
    return undefined;
  };

  const currentCategorySlug = getCategorySlugFromPath(router.asPath);
  const isLearningCenterPage = router.asPath.includes('learning-center');

  const webBanner = pageWebBanner ?? (() => {
    if (isLearningCenterPage && articleConfig?.categorySpecificWebBanner && articleConfig.categorySpecificWebBanner.length > 0) {
      // Use category-specific banner logic for learning center pages with category-specific banners
      return getLearningCenterBanner(
        articleConfig,
        currentCategorySlug,
        articleConfig?.globalWebBanner ?? globalWebBanner
      );
    } else {
      // Use global banner for non-learning center pages or when no category-specific banners exist
      return articleConfig?.globalWebBanner ?? globalWebBanner;
    }
  })();

  const { sys, fields }: any = webBanner ?? {};

  switch (sys?.contentType?.sys?.id) {
    case 'variationContainer':
      // Do not lazy load
      fields.variations!.forEach((variation: IVariation) => {
        if (variation!.fields?.pageBlock) {
          variation!.fields.pageBlock!.fields = {
            ...variation!.fields.pageBlock!.fields,
            toggleBanner,
            roundedCornersVariation
          } as any;
        }
      });
      return <VariationContainer {...fields} sysId={sys?.id} />;

    case 'webBanner':
      return (
        <WebBanner
          {...fields}
          toggleBanner={toggleBanner}
          roundedCornersVariation={roundedCornersVariation}
        />
      );

    default:
      return null;
  }
}
